import ContactPage from '../../components/elements/ContactPage';
import { imageConstraints } from '../../utils/constraints';

const Contact = () => {
  return (
    <ContactPage
      title="Contato"
      image={imageConstraints['Contact-Hero']}
      addressLine1="Av. Presidente Juscelino Kubitschek, 900 Oitavo andar - Moinho"
      addressLine2="Francisco Bernardino - Juiz de Fora - MG"
      facebookUrl="https://www.facebook.com/App-Masters-1389727984407110/"
      instagramUrl="https://www.instagram.com/appmasters.io/"
      linkedinUrl="https://br.linkedin.com/company/appmasters.io"
      websiteUrl="https://appmasters.io"
    />
  );
};

export default Contact;
